import { CommonModule, isPlatformBrowser } from "@angular/common";
import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { Router, RouterModule, RouterOutlet } from "@angular/router";
import { TermsOfServiceComponent } from "./terms-of-service/terms-of-service.component";
import { EmailPolicyComponent } from "./email-policy/email-policy.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";

declare var $: any;
@Component({
  selector: "app-our-policies",
  templateUrl: "./our-policies.component.html",
  styleUrls: ["./our-policies.component.css"],
  imports: [
    HeaderComponent,
    FooterComponent,
    CommonModule,
    RouterModule,
    RouterOutlet,
    // TermsOfServiceComponent, EmailPolicyComponent, PrivacyPolicyComponent, SecurityComponent
  ]
})
export class OurPoliciesComponent implements OnInit {
  isUserLoggedIn: boolean = false;
  userDetail: any;
  activePolicy: any;
  isBrowser: boolean;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.router.url.includes("terms-of-service")) {
      this.activePolicy = "terms-of-service";
    }
    if (this.router.url.includes("email-policy")) {
      this.activePolicy = "email-policy";
    }
    if (this.router.url.includes("privacy-policy")) {
      this.activePolicy = "privacy-policy";
    }
    if (this.router.url.includes("security")) {
      this.activePolicy = "security";
    }
  }

  setUserDetails(data) {
    this.userDetail = data.userDetail;
  }
}